import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { EventsReviewsControllerModule } from './controllers/EventsReviewsController';

export const EventsReviewsView = angular.module( 'acme.view.events.reviews', [
  uiRouter,
  'ui.bootstrap',
  EventsReviewsControllerModule
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var eventsReviews = {
        name: 'events.reviews',
        url: '/reviews?date',
        views: {
          "subview-main": {
            controller: 'EventsReviewsController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/reviews/reviews.tpl.html'
          }
        },
        data: {
          pageTitle: 'Reviews'
        }
      };

    $stateProvider
      .state(eventsReviews);
}).name;
